export const PhoneNumberSettingsReadme = {
  tool: [
    "The Phone Numbers tool allows you to identify special phone numbers and set up special behaviors for them.",
    "This tool can be used to suppress known phone numbers such as Center phone numbers.",
    "A future release will extend support to blocking known phone numbers from reaching the PAC."
  ],
  type: [
    "The type of the phone number will change its behavior within GEM.",
    "'No Action' is the default type, and no special action will be taken for numbers with this type.",
    "'Suppress' is intended for numbers which are allowed to call the PAC, but should not be saved to guest records. These include center phone numbers.",
    "'Blocked' is intended for numbers which are not allowed to call the PAC."
  ]
};
